export interface ITimePickerResourceStrings {
    igx_time_picker_ok?: string;
    igx_time_picker_cancel?: string;
}

export const TimePickerResourceStringsEN: ITimePickerResourceStrings = {
    igx_time_picker_ok: 'OK',
    igx_time_picker_cancel: 'Cancel'
};
